import isLoading, * as fromIsLoading from './isLoading';
import { combineReducers } from 'redux';

export default combineReducers({
  isLoading
});

export const getIsLoading = state => fromIsLoading.getIsLoading(state.isLoading);